<template>
    <zen-message-modal :isOpen="isOpen" title="Remove user?">
        Removing a user will prevent the user from logging into this account.
        <template v-slot:buttons>
            <zen-button
                variant="secondary"
                size="medium"
                @click="$emit('close')"
            >
                Cancel
            </zen-button>
            <zen-button
                variant="primary-danger"
                size="medium"
                :processing="processing"
                @click="$emit('confirm')"
            >
                Remove
            </zen-button>
        </template>
    </zen-message-modal>
</template>

<script>
export default {
    name: 'RemoveUserModal',
    props: {
        isOpen: {
            type: Boolean,
            required: true,
        },
        processing: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['close', 'confirm'],
}
</script>
